import {IconEye, IconEyeOff} from "@tabler/icons-react";
import {Form, Input, notification} from "@ui";
import {useTranslation} from "react-i18next";
import {PrimaryButton} from "@/components/Button";
import useUpdatePassword from "../../../hooks/useUpdatePassword";
import styles from "./ChangePassword.module.css";

const ChangePasswordForm = () => {
  const {postUpdate, isPending} = useUpdatePassword();

  const {t} = useTranslation();

  const onFinish = values => {
    postUpdate({
      old_password: values.current_password,
      new_password: values.new_password,
    });
    notification.success({
      message: "Contraseña actualizada",
    });
  };
  const onFinishFailed = _errorInfo => {};

  return (
    <Form
      name="basic"
      className={styles.change_pass_form}
      initialValues={{remember: true}}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      autoComplete="off"
      layout="vertical"
    >
      <Form.Item
        name="current_password"
        rules={[
          {
            required: true,
            message: t("changePasswordMessage"),
          },
        ]}
        style={{width: "100%"}}
      >
        <Input.Password
          placeholder={t("changeCurrentPassword")}
          className={styles.change_pass_Input}
          iconRender={visible =>
            visible ? (
              <IconEye
                size={20}
                stroke={1.5}
                className={styles.eyeIcon}
              />
            ) : (
              <IconEyeOff
                size={20}
                stroke={1.5}
                className={styles.eyeIcon}
              />
            )
          }
        />
      </Form.Item>
      <Form.Item
        name="new_password"
        rules={[
          {
            required: true,
            message: t("changePasswordMessage"),
          },
        ]}
        style={{width: "100%"}}
      >
        <Input.Password
          placeholder={t("changeNewPassword")}
          className={styles.change_pass_Input}
          iconRender={visible =>
            visible ? (
              <IconEye
                size={20}
                stroke={1.5}
                className={styles.eyeIcon}
              />
            ) : (
              <IconEyeOff
                size={20}
                stroke={1.5}
                className={styles.eyeIcon}
              />
            )
          }
        />
      </Form.Item>

      <Form.Item
        name="confirm_password"
        dependencies={["new_password"]}
        rules={[
          {
            required: true,
            message: t("changePasswordMessage"),
          },
          ({getFieldValue}) => ({
            validator(_, value) {
              if (!value || getFieldValue("new_password") === value) {
                return Promise.resolve();
              }
              return Promise.reject(new Error(t("changePasswordError")));
            },
          }),
        ]}
        style={{width: "100%"}}
      >
        <Input.Password
          placeholder={t("changeConfirmNewPassword")}
          className={styles.change_pass_Input}
          iconRender={visible =>
            visible ? (
              <IconEye
                size={20}
                stroke={1.5}
                className={styles.eyeIcon}
              />
            ) : (
              <IconEyeOff
                size={20}
                stroke={1.5}
                className={styles.eyeIcon}
              />
            )
          }
        />
      </Form.Item>

      <Form.Item className={styles.centeredBtn}>
        <PrimaryButton
          htmlType="submit"
          loading={isPending}
        >
          {t("changePasswordBtn")}
        </PrimaryButton>
      </Form.Item>
    </Form>
  );
};
export default ChangePasswordForm;
